import React, { useEffect } from 'react';
import { initAnalytics, trackPageView } from './utils/analytics';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { LogoBar } from './components/LogoBar';
import { Features } from './components/Features';
import { Stats } from './components/Stats';
import { HowItWorks } from './components/HowItWorks';
import { Frameworks } from './components/Frameworks';
import { Personas } from './components/Personas';
import { Testimonials } from './components/Testimonials';
import { Pricing } from './components/Pricing';
import { FAQ } from './components/FAQ';
import { TrustStrip } from './components/TrustStrip';
import { CTASection } from './components/CTASection';
import { Footer } from './components/Footer';
export function App() {
  useEffect(() => {
    initAnalytics();
    trackPageView(window.location.pathname + window.location.search);
  }, []);
  return <div className="min-h-screen bg-white font-sans selection:bg-teal-100 selection:text-teal-900" data-id="element-0" data-mp="23w4ek0vqj40u">
      <Navbar data-id="element-1" data-mp="3ikqwhsrnks2k" />
      <main data-id="element-2" data-mp="3ij65ue8glt9z">
        <Hero data-id="element-3" data-mp="3ijpbavgxap74" />
        <Features data-id="element-4" data-mp="3ihuyk4ft23e4" />
        {/* <Testimonials /> */}
        <HowItWorks data-id="element-5" data-mp="3mkhmhu9cv461" />
        <Stats data-id="element-6" data-mp="3mjzu58ptda3e" />
        <Frameworks data-id="element-7" data-mp="3mjga9mglsbmq" />
        <Personas data-id="element-8" data-mp="3rc9ca2kot5v4" />
        <Pricing data-id="element-9" data-mp="3rbrc4uuwm7hx" />
        <FAQ data-id="element-10" data-mp="3rdarmj8qkein" />
        {/* <TrustStrip /> */}
        <CTASection data-id="element-11" data-mp="3relvej26lm9r" />
      </main>
      <Footer data-id="element-12" data-mp="6htjo98ovic" />
    </div>;
}